import $ from "jquery";

const ToggleMapFilterView = (el) => {
    const $el = $(el);
    const $toggleButtons = $el.find(".js-toggle-map-filter-view-button");
    const $mapToggleButton = $toggleButtons.filter('[data-filter-type="map"]');
    const $listToggleButton = $toggleButtons.filter('[data-filter-type="list"]');
    const $sortOptions = $(".js-archive-sort");
    const $filterOptions = $(".js-archive-difficulty-filter");

    //sets toggle state on click
    $toggleButtons.on("click", function (event) {
        $toggleButtons.removeClass("active");
        $(this).toggleClass("active");
    });

    //handle on view states on page load or update
    const isMapView = () => {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get('view') === 'map';
    }

    if(isMapView()) {
        $mapToggleButton.addClass('active');
        $listToggleButton.removeClass('active');

    } else {
        $listToggleButton.addClass('active');
        $mapToggleButton.removeClass('active');

        $sortOptions.show();
        $filterOptions.show();
        $listToggleButton.addClass('active');
    }

};

export default ToggleMapFilterView;
